import { Button, Layout, Menu } from "antd";
import { useSelector } from "react-redux";
import { DatabaseOutlined } from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import dsquaresLogo from "src/assets/logo-dark.svg";
import smallDsquaresLogo from "src/assets/logo192.png";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import clsx from "clsx";
import { useState } from "react";
import { capitalize } from "src/utility/utility";
import { getProgram } from "src/store/slices/auth";
import { useCheckAccess } from "src/HOC/withRBAC";

const initialTabs = [
  {
    key: "0",
    icon: <DatabaseOutlined />,
    label: <NavLink to="/">Transactions</NavLink>,
  },
];

export default function SideBar() {
  const checkAccess = useCheckAccess();
  const [collapsed, setCollapsed] = useState(false);
  const programFeatures = useSelector(getProgram)?.features ?? [];

  const featureTabs = programFeatures.map((feature) => ({
    key: String(feature),
    icon: <DatabaseOutlined />,
    label: <NavLink to={`/${feature}`}>{capitalize(feature)}</NavLink>,
  }));

  const tabs = [...initialTabs, ...featureTabs].filter((tab) => {
    if (tab.key === "sync") return checkAccess("sync");
    return true;
  });

  return (
    <Layout.Sider
      className="bg-white"
      trigger={null}
      collapsible
      collapsed={collapsed}
    >
      <div className="p-5 pb-11">
        <NavLink to={"/"} className="flex-shrink-0">
          <img
            src={collapsed ? smallDsquaresLogo : dsquaresLogo}
            alt="Dsquares"
            className="h-8 transition-all duration-300"
          />
        </NavLink>
      </div>
      <Menu mode="inline" defaultSelectedKeys={["1"]} items={tabs} />

      <div
        className={clsx(
          "fixed bottom-0 left-0 flex justify-around",
          collapsed ? " w-[80px] " : " w-[200px] ",
        )}
      >
        <Button
          size="small"
          type="text"
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={() => setCollapsed(!collapsed)}
          className={clsx({
            "h-11  rounded-none  bg-white hover:bg-slate-100": true,
          })}
        />
      </div>
    </Layout.Sider>
  );
}
